import { useParams } from "react-router-dom";

import { PAGE_TITLES } from "~/configs/pageTitles";
import { usePageTitle } from "~/hooks/usePageTitle";

import SiteSettings from "../../../components/siteSettings/SiteSettings";
import Breadcrumbs from "../../../components/ui/breadcrumbs/Breadcrumbs";
import styles from "./SiteSettingsPage.module.scss";

const SiteSettingsPage = () => {
  usePageTitle(PAGE_TITLES.siteSettings);
  const { id } = useParams();
  const fakeBreadcrumbs = [
    {
      title: PAGE_TITLES.dashboard,
      link: "/",
    },
    {
      title: PAGE_TITLES.siteSettings,
      link: `/sites/${id}/settings`,
    },
  ];

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{PAGE_TITLES.siteSettings}</h1>
      <>
        {fakeBreadcrumbs?.length && (
          <Breadcrumbs fakeBreadcrumbs={fakeBreadcrumbs} />
        )}
      </>
      <SiteSettings />
    </div>
  );
};
export default SiteSettingsPage;
